import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { selectPlace, selectTarget, setPlace } from './familySlice'
import { sendAnalyticsEvents } from '../../analytics/common'
import { EVENTS } from '../../analytics/events'
import { fontSize, tabletMinWidth } from '../../mixins'
import { StyledList, StyledItem } from './ChooseTarget'
import UIButton from '../../UI/UIButton'
import MainContainer from '../../UI/MainContainer'
import { selectEventsData, setEventData } from '../events/eventsSlice'
import { selectLandingTypeB } from '../plans/plansSlice'

const Title = styled.h1`
  font-weight: 600;
  ${fontSize(32)};
  line-height: 38px;
  text-align: center;
  color: #323232;
  margin: 15px 0 8px 0;
  ${({ onePage }) => onePage && 'margin-top: 0;'}
  // max-width: ${({ target }) => (target === 'pet' ? '250px' : '270px')};

  @media screen and (min-width: ${tabletMinWidth}px) {
    margin: 0 0 24px 0;
  }
`

const Description = styled.p`
  width: 234px;
  margin: 0 0 15px 0;
  text-align: center;
  ${fontSize(16)};
  line-height: 22px;
  color: #5b5b5b;

  @media screen and (min-width: ${tabletMinWidth}px) {
    margin-bottom: 48px;
  }
`

const CreatePlace = ({ history, onePage }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const target = useSelector(selectTarget)
  const place = useSelector(selectPlace)
  const eventsData = useSelector(selectEventsData)
  const skipMap = true
  const [readyToChoose, setReadyToChoose] = useState(false)
  const [initEventSent, setInitEventStatus] = useState(false)
  const [initEventSent2, setInitEventStatus2] = useState(false)
  const [whichPlace, setWhichPlace] = useState(null)
  const isLandingTypeB = useSelector(selectLandingTypeB)
  const isDisabled = !!whichPlace

  useEffect(() => {
    if (initEventSent) return
    setInitEventStatus(true)
  }, [eventsData, initEventSent])

  useEffect(() => {
    if (readyToChoose && !initEventSent2 && !onePage) {
      window.scrollTo(0, 0)
      sendAnalyticsEvents(EVENTS.onboardingDisplayPlacesShown, eventsData)
      setInitEventStatus2(true)
    }
  }, [readyToChoose, initEventSent2, eventsData, onePage])

  useEffect(() => setReadyToChoose(!!place), [place])

  const onContinueClick = () => {
    dispatch(setEventData({ id: 'Places', data: whichPlace }))
    sendAnalyticsEvents(EVENTS.onboardingDisplayPlacesSubmitted, {
      ...eventsData,
      Places: whichPlace,
    })
    dispatch(setPlace(whichPlace))
    setTimeout(
      () =>
        history.push(
          `/${
            skipMap
              ? isLandingTypeB
                ? 'signup'
                : 'creating-your-profile'
              : 'add-place'
          }`
        ),
      200
    )
  }

  const BUTTONS = ['home', 'work', 'school', 'custom']

  const renderItem = (i, index) => {
    return (
      <StyledItem
        onClick={() => setWhichPlace(i)}
        active={i === whichPlace}
        key={index}
        onePage={onePage}
      >
        <span>{t(i)}</span>
      </StyledItem>
    )
  }

  return (
    <MainContainer adaptiveHeight={830} customPadding={onePage ? '0' : '0 24px 100px'}>
      <Title target={target}>{`${t('be_sure_' + (target || 'other'))}`}</Title>
      <Description>{t('add_place_description_' + (target || 'other'))}</Description>
      <StyledList onePage={onePage}>{BUTTONS.slice(0,onePage ? 3 : 4).map(renderItem)}</StyledList>
      {!onePage && (
        <UIButton onClick={onContinueClick} disabled={!isDisabled} bottomPosition={'24px'} displayStickyBtn={!onePage}>
          {t('continue')}
        </UIButton>
      )}
    </MainContainer>
  )
}

export default CreatePlace
